
import helper from '../helper'

const _h = (obj) => {
	return helper.creatObject(obj)
}

const alertBlock = () => {

    let close = document.querySelectorAll('.wp-block-hayyabuild-alert__close')
    
    close && close.forEach( element => {

        const alertBox = element.parentElement // paernt of link (alert box)
        const ID = alertBox.id // alert ID
        const remembrtDismissible = alertBox.classList && alertBox.classList.contains('wp-block-hayyabuild-alert--remembrt-dismissible')

        if ( getCookie( ID ) === 'c' && remembrtDismissible ) {
            _h( alertBox ).css({
                opacity: '0',
                display: 'none'
            });
        } else {

            remembrtDismissible && alertBox.classList.remove('wp-block-hayyabuild-alert--remembrt-dismissible')

            element.addEventListener( 'click', ( event ) => {
                event.preventDefault()
                alertBox.style.opacity = '0'

                setTimeout( () => {
                    alertBox.style.display = 'none'
                }, 500)

                remembrtDismissible && setCookie( ID )
            })
        }
    })

    // setCookie( ID, 'c', -1 ); // c means closed;

    /**
     * Sets the cookie.
     *
     * @param      {string}  ID      { parameter_description }
     * @param      {string}  cvalue  The cvalue
     * @param      {number}  exdays  The exdays
     */
    function setCookie( ID ) {
        let d = new Date();
        d.setTime( d.getTime() + (7 * 24 * 60 * 60 * 1000) );
        let expires = d.toUTCString();
        document.cookie = `${ID}=c;expires=${expires}` // c means closed
    }
    
    /**
     * Gets the cookie.
     *
     * @param      {string}  ID      alert ID
     * @return     {string}  The cookie.
     */
    function getCookie( ID ) {
        let name = `${ID}=`
        let cookies = document.cookie.split(';')
        let value = ''

        cookies.length && cookies.forEach( c => {
            c = c.trim()
            if ( c.indexOf(name) === 0 ) {
                value = c.replace( name, '')
            }
        })
        return value;
    }

}

export default alertBlock;
